/*
 * Documents kept on a record's lines — a receipt behind a journal line.
 *
 * One entry serves every place that shows them: the side panel (desktop), the
 * documents button on each line, and the modal that button opens on mobile.
 * Those places name the entry with `lineDocuments: '<key>'`.
 *
 *   linesArray   the array whose items carry `attachments`
 *   folder       storage folder for uploads
 *   accept       file types the upload offers
 *   locked       when the record is locked: documents can still be added, and
 *                removing one only marks it deleted (the server enforces this
 *                too — mergeLockedAttachments)
 *   lineLabel    the line's heading — ${1} is the line number, the rest
 *                `lineLabelParams` read off the line
 */
export const lineDocumentsData = {
    journalLine: {
        linesArray: 'lines',
        folder: 'journals',
        accept: '.pdf,.png,.jpg,.jpeg,.gif,.webp',
        locked: { condition: { field: 'state', operator: 'notEquals', value: 'draft' } },
        lineLabel: 'journal.documents.line',
        lineLabelParams: ['accountNo', 'accountIdName']
    }
}
